import React, { useState } from 'react';
import OneHotelView from '../views/OneHotelView';
import OneHotelMobileView from '../views/OneHotelMobileView';

const OneHotel = ({
  hotel,
  localDeparture,
  requestModel,
  geoclient,
  recomend_hotels = [],
  onAction,
  onContinue,
  getHotelInfo,
  filteredOperators,
  hotelsIdWithReviews
}) => {
  const [sort, setSort] = useState('price');

  const handleSetSort = (type = 'price') => {
    setSort(type);
  };

  const recomend =
    recomend_hotels.indexOf(`${hotel.hotelcode}`) != -1 ? true : false;

  let hasGeograftourReviews;

  if (hotelsIdWithReviews?.length > 0) {
    hasGeograftourReviews = hotelsIdWithReviews.includes(
      hotel.hotelcode.toString()
    );
  }

  if (hotel.tours.tour?.length === 0) {
    return;
  } else {
    return !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? (
      <OneHotelView
        key={`hotel-${hotel.hotelcode}`}
        row={hotel}
        departure={localDeparture}
        recomend={recomend}
        geoclient={geoclient}
        onAction={onAction}
        requestModel={requestModel}
        onContinue={onContinue}
        sort={sort}
        onSort={handleSetSort}
        getHotelInfo={getHotelInfo}
        filteredOperators={filteredOperators}
        hasGeograftourReviews={hasGeograftourReviews}
      />
    ) : (
      <OneHotelMobileView
        key={`m-${hotel.hotelcode}`}
        row={hotel}
        departure={localDeparture}
        recomend={recomend}
        geoclient={geoclient}
        requestModel={requestModel}
        onAction={onAction}
        onContinue={onContinue}
        sort={sort}
        onSort={handleSetSort}
        getHotelInfo={getHotelInfo}
        filteredOperators={filteredOperators}
        hasGeograftourReviews={hasGeograftourReviews}
      />
    );
  }
};

export default OneHotel;
